export const pageSize = process.env.REACT_APP_PAGE_SIZE || 25;
